import fetch from 'isomorphic-fetch';
import { detect } from 'detect-browser';
const browser = detect();

const API = {
  data: {
    async getAll(obj) {
      let response = await fetch(`/api/accountExtendedProperty/${encodeURIComponent(JSON.stringify(obj))}`, {
        method: 'GET',
        headers: new Headers({
          Pragma: 'no-cache'
        })
      });

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async handleExtendedProperty(item) {
      const response = await fetch(`/api/accountExtendedProperty`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Pragma: 'no-cache'
        }),
        body: JSON.stringify(item)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleUpdateExtendedProperty(item) {
      const response = await fetch(`/api/accountExtendedProperty/`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }),
        body: JSON.stringify(item)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleDeleteExtendedProperty(obj) {
      const response = await fetch(`/api/accountExtendedProperty/${JSON.stringify(obj)}`, {
        method: 'DELETE'
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    }
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/account_extended_property/api/index.js